import type {
  CompleteCheckoutRequestDto,
  ExecuteCheckinRequestDto,
  MoveStayRoomRequestDto,
  RegisterGuestDocumentRequestDto,
} from "./dtos.ts";

function hasText(value: string | undefined) {
  return Boolean(value?.trim());
}

export function validateRegisterGuestDocumentRequest(input: RegisterGuestDocumentRequestDto) {
  const errors: Record<string, string> = {};
  if (!hasText(input.guestId)) errors.guestId = "Guest is required.";
  if (!hasText(input.documentNumber)) errors.documentNumber = "Document number is required.";
  if (!hasText(input.nationality)) errors.nationality = "Nationality is required.";
  return errors;
}

export function validateExecuteCheckinRequest(input: ExecuteCheckinRequestDto) {
  const errors: Record<string, string> = {};
  if (!hasText(input.reservationId)) errors.reservationId = "Reservation is required.";
  if (!hasText(input.roomId)) errors.roomId = "Room is required.";
  if (input.documentChecked !== true) errors.documentChecked = "Confirm that the guest document has been checked.";
  return errors;
}

export function validateMoveStayRoomRequest(input: MoveStayRoomRequestDto) {
  const errors: Record<string, string> = {};
  if (!hasText(input.stayId)) errors.stayId = "Stay is required.";
  if (!hasText(input.toRoomId)) errors.toRoomId = "Target room is required.";
  return errors;
}

export function validateCompleteCheckoutRequest(input: CompleteCheckoutRequestDto) {
  const errors: Record<string, string> = {};
  if (!hasText(input.stayId)) errors.stayId = "Stay is required.";
  if (!Number.isFinite(input.settlementAmount) || input.settlementAmount < 0) {
    errors.settlementAmount = "Settlement amount must be 0 or greater.";
  }
  if (!hasText(input.currency)) errors.currency = "Currency is required.";
  return errors;
}
